<template>
  <div class="database"  style="background-color: #f1f1f1;">
    <navtab class="navTab"></navtab>
    <!-- <div>{{pageIndex}}</div> -->
    <div class="databaseContPart" v-show="!aaa">
      <!-- 导航菜单 -->
      <ul class="tac">
        <li class="el-icon-arrow-left arMag" @click="toLast()"></li>
        <li
          @click="getDataList(val.id,index)"
          id="newLi"
          v-for="(val,index) in typeList"
          :key="index"
          :index="current"
          :class="index==current?'perstyle':''"
        >{{val.name}}</li>
        <li class="el-icon-arrow-right fixLi" @click="toNext()"></li>
      </ul>
      <!-- <el-row class="tac">
            <el-col :span="12">
              <el-menu
                default-active="2"
                class="el-menu-vertical-demo"
                @open="handleOpen"
                @close="handleClose"
                background-color="#fdfdfd"
                text-color="#000000"
                active-text-color="#000000">
                <el-menu-item @click="getDataList(val.id)" v-for="(val,index) in typeList" :key="index" index="index+1">
                  <span slot="title">{{val.name}}</span>
                </el-menu-item>
              </el-menu>
            </el-col>
      </el-row>-->
      <ul class="databaseCont">
        <li
          class="databaseContModel"
          :style="{'height':heightScOne+'px','margin-bottom':mgBottom+'px'}"
          v-for="(val,index) in dataList"
          :key="index"
          @click="isShowDetail(val.id)"
        >
          <div class="liLef">
            <img :src="val.imgurl" alt />
          </div>
          <div class="liRig">
            <p class="liRigTitle">{{val.name}}</p>
            <p class="liRigDesc">{{val.describe}}</p>
          </div>
        </li>
        <!-- <h2 v-show="!dataList.length>0">暂无数据</h2> -->
        <div class="noDataDiv" v-show="dataList.length==0">
            <img src="../assets/noData.png" alt />
        </div>
        <p class="noDataP" v-show="dataList.length==0">暂无数据</p>
        <li class="databaseContModel" id="noUseLi" :style="{height:heightScOne+'px'}">
          <div class="liLef">
            <img src="../assets/5.png" alt />
          </div>
          <div class="liRig">
            <p class="liRigTitle">气动电子技术气动电子技术</p>
            <p class="liRigDesc">浙江大学流体动力与机电系统 国家重点实验室</p>
          </div>
        </li>
      </ul>
    </div>

    <!-- 所有浏览器都支持 < iframe > 标签，直接将src设置为指定的PDF文件就可以预览了。此外可以把需要的文本放
    置在 < iframe > 和 之间，这样就可以应对无法理解 iframe 的浏览器，比如下面的代码可以提供一个PDF的下载链接：-->

    <div class="databaseDetail" v-show="aaa">
      <div class="lef">
        <p class="newBackP el-icon-arrow-left" @click="showDatabase">返回</p>
        <p class="title">{{dataCont.name}}</p>
        <ul class="liPar">
          <li class="time">
            <span class="el-icon-time"></span>
            <span>{{dataCont.modifytime}}</span>
          </li>
          <li class="save" @click="collectData()">
            <!-- <span class="el-icon-star-off"></span> -->
            <img v-show="!isSave" src="../assets/saveShow.png" alt />
            <img v-show="isSave" src="../assets/saveHidden.png" alt />
            <span>收藏（{{dataAbout.collectEntities}}）</span>
          </li>
          <li id="upload">
            <a :href="pdfUrl" :download="dataCont.name"></a>
            <span class="el-icon-download"></span>
            <span>下载</span>
          </li>
          <li>
            <span class="el-icon-edit-outline"></span>
            <span>评论（{{commentNum}}）</span>
          </li>
        </ul>
        <!-- <iframe src="../assets/docu.pdf" width="100%" height="300%">
                    This browser does not support PDFs. Please download the PDF to view it: <a href="../assets/docu.pdf">Download PDF</a>
        </iframe>-->
        <!-- <embed src="../assets/docu.pdf" type="application/pdf" width="50%" height="200%" :style="embedStyle" /> -->
        <!-- <pdf src="../assets/docu.pdf"></pdf> -->
        <div id="pdf" style="width:100%;height:1000px"></div>
      </div>
      <div class="rig">
        <p class="comment">评论</p>
        <ul class="commentPar">
          <li class="commentParLi" v-for="(val,index) in commentList" :key="index">
            <span
              class="commentName"
              v-text="val.userInfoEntity.nickName?val.userInfoEntity.nickName+':':'匿名:'"
            >匿名:</span>
            <span class="commentCont">{{val.content}}</span>
            <span class="commentTime">{{val.createtime.substr(0,10)}}</span>
          </li>
        </ul>
        <el-pagination
          v-show="total!=0"
          background:true
          :page-size="10"
          :current-page="currentPage"
          layout="prev, pager, next"
          @current-change="changePage"
          :total="total"
        ></el-pagination>
        <textarea
          name
          id
          cols="30"
          rows="10"
          placeholder="写评论"
          class="commentTextArea"
          v-model="content"
        ></textarea>
        <div class="submitBtn" @click="submitComments()">发表评论</div>
      </div>
    </div>
    <!-- <div class="address" v-html="htmlWord"></div> -->
  </div>
</template>

<script>
import pdf from "vue-pdf";
import navtab from "./navtab";
export default {
  name: "database",
  components: {
    navtab: navtab,
    pdf: pdf
  },
  data() {
    return {
      mgBottom:"",
      // htmlWord:
      //   "Copyright&nbsp©&nbsp2016-2019&nbsp浙江桃园科技有限公司&nbsp&nbsp|&nbsp&nbsp 技术支持：杭州互办网络科技有限公司",
      currentPage: 1,
      totalNum: "",
      isSave: false,
      aaa: false,
      //   pdfUrl: "http://image.cache.timepack.cn/nodejs.pdf"
      pdfUrl: "",
      //   embedStyle:{
      //       width:'80%'
      //   }
      typeList: [],
      dataList: [],
      // username: "13849319619",
      dataCont: "",
      dataId: "",
      dataAbout: "",
      user: "",
      content: "",
      commentNum: "",
      current: 0,
      pageIndex: 0,
      commentList: [],
      total: 0,
      heightScOne:""
    };
  },

  methods: {
    changePage(currentPage) {
      this.currentPage = currentPage;
      this.total = this.dataAbout.commentList.length;
      //console.log(currentPage);
      //console.log(this.dataAbout.commentList);
      let start = 10 * (this.currentPage - 1);
      let end = 10 * (this.currentPage - 1) + 10;
      //console.log(start, end);
      this.commentList = this.dataAbout.commentList.slice(start, end);
      //console.log(this.commentList);
    },
    toLast() {
      if (this.current == 0) {
        this.current = this.typeList.length - 1;
      } else {
        this.current = this.current - 1;
      }
      this.getDataList(this.typeList[this.current].id, this.current);
    },
    toNext() {
      if (this.current == this.typeList.length - 1) {
        this.current = 0;
      } else {
        this.current = this.current + 1;
      }
      this.getDataList(this.typeList[this.current].id, this.current);
    },
    // <p class="newBackP" @click="showDatabase">返回</p>
    showDatabase() {
      this.aaa = false;
    },
    //导航菜单
    handleOpen(key, keyPath) {
      //console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      //console.log(key, keyPath);
    },
    // /api/Yddatabase/classification获取资料库分类
    getDataType() {
      //console.log("222");
      this.$axios
        .get(this.$http + "api/Yddatabase/classification")
        .then(res => {
          if (res.data.code == 0) {
            //console.log("获取资料库分类成功");
            //console.log(res.data);
            this.typeList = res.data.Entity;
            this.getDataList(this.typeList[0].id, 0);
          } else {
            //console.log("获取资料库分类失败");
          }
        })
        .catch(err => {});
    },
    // /api/Yddatabase/database/{classId}按分类查询资料库
    getDataList(typeId, index) {
      // document.getElementById('newLi')[index].classList.add("myNewstyle");
      // document.getElementById('newLi')[index].siblings.classList.remove("myNewstyle");
      // .el-menu li
      this.current = index;
      //console.log(this.current, index, this.current == index);
      //console.log("111");
      this.$axios
        .get(this.$http + "api/Yddatabase/database/" + typeId)
        .then(res => {
          if (res.data.code == 0) {
            //console.log("获取成功");
            //console.log(res.data);
            this.dataList = res.data.Entity;
          } else {
            //console.log("获取失败");
          }
        })
        .catch(err => {});
    },
    // /api/Yddatabase/SelectByDatabaseId/{dataId}/{userName}通过资料ID查询内容
    isShowDetail(dataId) {
      // //console.log(this.username);
      //console.log(dataId);
      this.dataId = dataId;
      this.aaa = true;
      this.$axios
        .get(
          this.$http +
            "api/Yddatabase/SelectByDatabaseId/" +
            dataId +
            "/" +
            this.user.userName
        )
        .then(res => {
          if (res.data.code == 0) {
            //console.log("获取成功");
            //console.log(res.data);
            //console.log(res.data.Entity.collectType, this.isSave);
            if (res.data.Entity.collectType == 1) {
              //1是收藏 2 是否
              this.isSave = false;
            } else {
              this.isSave = true;
            }
            this.dataCont = res.data.Entity;
            this.pdfUrl = this.dataCont.fileurl;
            document.getElementById("pdf").innerHTML =
              '<embed src="' +
              this.pdfUrl +
              '"  style="width:100%;height:1000px"/>';
            this.getDataAbout();
          } else {
            //console.log("获取失败");
          }
        })
        .catch(err => {});
    },

    // /api/Yddatabase/SelectCollection/{dataId}按资料ID查询收藏和评论数量以及评论列表
    getDataAbout() {
      this.$axios
        .get(this.$http + "api/Yddatabase/SelectCollection/" + this.dataId)
        .then(res => {
          if (res.data.code == 0) {
            //console.log("获取收藏和评论数量以及评论列表成功");
            //console.log(res.data);
            this.dataAbout = res.data;
            //console.log(this.dataAbout);
            this.commentNum = this.dataAbout.commentList.length;
            this.dataAbout.commentList.reverse();
            //console.log(this.commentNum);
            this.changePage(this.currentPage);
          } else {
            //console.log("获取失败");
          }
        })
        .catch(err => {});
    },
    // 提交评论/api/Yddatabase/Comment评论资料插入 传入账号userName 内容content 资料ID databaseId
    submitComments() {
      if (sessionStorage.getItem("user")) {
        if (
          this.content != "" &&
          this.content != undefined &&
          this.content != null
        ) {
          let obj = {
            userName: this.user.userName,
            databaseId: this.dataId,
            content: this.content
          };
          let data = JSON.stringify(obj);
          this.$axios({
            method: "post",
            url: this.$http + "api/Yddatabase/Comment",
            headers: {
              "Content-Type": "application/json"
            },
            data: data
          })
            .then(res => {
              if (res.data.code == 0) {
                //console.log(res);
                // alert("评论成功");
                this.$notify({
                  title: "成功",
                  message: "恭喜您发表评论成功",
                  type: "success"
                });
                this.isLogin = true;
                this.content = "";
                this.getDataAbout();
              } else {
                this.$notify({
                  title: "提示",
                  message: "消息跑丢了，请小主重新提交！",
                  type: "warning"
                });
              }
            })
            .catch(err => {});
        } else {
          this.$notify({
            title: "温馨提示",
            message: "内容不能为空",
            type: "warning"
          });
        }
      } else {
        this.$notify({
          title: "温馨提示",
          message: "您还没有登录交流圈，请先登录",
          type: "warning"
        });
      var flag=2;
      sessionStorage.setItem("flag",flag)
      this.$router.push("/");
      }
    },
    // /api/Yddatabase/Collection/{dataId}/{userName}/{type}收藏资料增加
    collectData() {
      if (sessionStorage.getItem("user")) {
        this.$axios
          .get(
            this.$http +
              "api/Yddatabase/Collection/" +
              this.dataId +
              "/" +
              this.user.userName +
              "/" +
              3
          )
          .then(res => {
            //console.log(res);
            //console.log(this.isSave);
            if (res.data.code == 0) {
              // alert("收藏成功");
              // alert(res.data.msg);
              this.isSave = !this.isSave;
              //console.log(this.isSave);
              this.$notify({
                title: "成功",
                message: res.data.msg,
                type: "success"
              });
              this.getDataAbout();
              //console.log(res.data);
            } else {
              this.isSave = !this.isSave;
              // alert(res.data.msg);
              this.$notify({
                title: "温馨提示",
                message: res.data.msg,
                type: "warning"
              });
              this.getDataAbout();
            }
          })
          .catch(err => {});
      } else {
        var flag = 2;
        sessionStorage.setItem("flag", flag);
        this.$router.push("/");
        this.$notify({
          title: "温馨提示",
          message: "为了给您更加优质的服务，请先登录",
          type: "warning"
        });
      }
    }
  },

  created() {
    if (sessionStorage.routerDetailId != undefined) {
      this.aaa = true;
      this.dataId = JSON.parse(sessionStorage.getItem("routerDetailId"));
      this.isShowDetail(this.dataId);
      sessionStorage.removeItem("routerDetailId");
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      //  这里的vm指的就是vue实例，可以用来当做this使用
      //console.log(from);
      //console.log(from.fullPath);
      if (from.fullPath == "/perCenter") {
        //console.log(JSON.parse(sessionStorage.getItem("routerDetailId")));
        // this.seeDeatil(index)
        //     {
        // this.productId = this.hots[index].id;
        // this.dataId  = JSON.parse(sessionStorage.getItem("routerDetailId"));
        // this.aaa = true;
        // },
      }
    });
  },
  mounted() {
    var imgWidth=document.body.clientWidth*0.8*0.32*0.4;
    //console.log(imgWidth);
    this.heightScOne=(imgWidth*90)/121;
    //console.log(imgWidth,this.heightScOne);
    var liW= (document.body.clientWidth*0.8*0.32)+6*2;
    var blankWidth = (document.body.clientWidth*0.8-liW*3)/2;
    this.mgBottom=blankWidth;
    if (sessionStorage.getItem("user")) {
      this.user = JSON.parse(sessionStorage.getItem("user"));
    }
    this.getDataType();
    this.current = 1;
    //console.log(this.current);
  }
};
</script>

<style scoped>
.database .noDataDiv {
  width: 98px;
  height: 86px;
  /* background-color: pink; */
  margin: 0 auto;
  margin-top: 10%;
}
.database .noDataP {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  margin-top: 17px;
}
.database .noDataDiv img {
  display: block;
  width: 100%;
  height: 100%;
}
.fixLi {
  position: absolute;
  right: 0;
}
.newBackP {
  font-size: 16px;
  text-align: left;
  width: 100%;
  border-bottom: 1px solid #ccc;
  line-height: 30px;
  cursor: pointer;
  /* margin-top: 30px; */
  padding: 10px 15px;
  box-sizing: border-box;
}
#noUseLi {
  opacity: 0;
}
#upload {
  cursor: pointer;
  position: relative;
  margin-right:30px;
}
#upload a {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
}
#upload:hover {
  color: #158DD3;
}
.el-col-12 {
  width: 100%;
}
.el-menu li {
  margin: 3px 0;
  /* color: #fff !important; */
  font-size: 14px !important;
}
.el-menu li:hover {
  background-color: #158DD3 !important;
  color: #fff !important;
}

.database .navTab {
  box-shadow: 0px 4px 8px 0px rgba(102, 102, 102, 0.2);
  z-index:999;
}
.database .databaseContPart {
  /* display: flex;
  flex-direction: row;
  justify-content: center; */
  width: 80%;
  margin: 0 auto;
  margin-top: 1%;
}
.database .databaseContPart .tac {
  font-size: 14px;
  width: 100%;
  background-color: #158DD3;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin: 0 auto;
  color: #fff;
  position: relative;
}
.database .databaseContPart .tac li {
  /* width: 100%; */
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  text-align: center;
  /* background-color: pink; */
  /* margin-bottom: 3px; */
  /* font-weight: 600; */
  padding: 0 25px;
  cursor: pointer;
}
.database .databaseContPart .databaseCont {
  width: 100%;
  /* margin-left: 1%; */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 18px;
}
.database .databaseContPart .databaseCont .databaseContModel {
  width: 32%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 211px;
  /* margin: 1% 0; */
  cursor: pointer;
  /* background-color: #f7f7f7; */
  background-color: #fff;
  padding: 6px;
  margin-bottom: 12px;
  background: rgba(255, 255, 255, 1);
}
.database .databaseContPart .databaseCont .databaseContModel:hover {
  box-shadow: 0px 5px 15px 0px #666;
}
.database .databaseContPart .databaseCont .databaseContModel .liLef {
  height: 100%;
  width: 40%;
  border-radius: 8px;
  overflow: hidden;
  margin-right: 15px;
  position: relative;
}
.database .databaseContPart .databaseCont .databaseContModel .liLef img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 4px;
  overflow: hidden;
  transform: translate(-50%, -50%);
}
.database .databaseContPart .databaseCont .databaseContModel .liRig {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 50%;
}
.database
  .databaseContPart
  .databaseCont
  .databaseContModel
  .liRig
  .liRigTitle {
  font-size: 16px;
  color: black;
  font-weight: 600;
  width: 100%;
  text-align: left;
  margin: 6% 0;
}
.database .databaseContPart .databaseCont .databaseContModel .liRig .liRigDesc {
  font-size: 14px;
  color: #868686;
  font-weight: 400;
  width: 100%;
  text-align: left;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-height: 24px;
}
.database .databaseDetail {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.database .databaseDetail .lef {
  width: 80%;
  background-color: #fff;
  /* padding-left: 10px; */
}
.database .databaseDetail .lef .title {
  width: 100%;
  text-align: left;
  font-size: 24px;
  /* font-weight: 600; */
  margin: 25px 0;
  padding-left: 25px;
  box-sizing: border-box;
}
.database .databaseDetail .lef .liPar {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  color: #828181;
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 29px;
  padding-left: 22px !important;
  box-sizing: border-box;
}
#pdf {
  padding-left: 25px;
  box-sizing: border-box;
}
.database .databaseDetail .lef .liPar .save {
  cursor: pointer;
  margin: 0 30px;
  display: flex;
  align-items: center;
}
.database .databaseDetail .lef .liPar .save img {
  /* display: block; */
  width: 22px;
  height: 22px;
  position: relative;
  /* top:3px; */
}
.database .databaseDetail .lef .liPar .save:hover {
  color: #158DD3;
}
.database .databaseDetail .lef .liPar li span {
  margin: 0 3px;
}
.database .databaseDetail .lef .pdfPar {
  width: 100%;
  margin: 0 auto;
}
.database .databaseDetail .rig {
  width: 20%;
  background-color: #fff;
  /* margin-left: 1%; */
}
.database .databaseDetail .rig .comment {
  width: 80%;
  font-size: 22px;
  /* font-weight: 600; */
  text-align: left;
  margin: 28px auto 10px;
}
.database .databaseDetail .rig .commentPar {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 20px;
}
.database .databaseDetail .rig .commentPar .commentParLi {
  width: 100%;
  font-size: 14px;
  line-height: 26px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  text-align: left;
  /* border-bottom: 1px solid #ccc; */
}
.database .databaseDetail .rig .commentPar .commentParLi .commentName {
  width: 20%;
  text-overflow: ellipsis;
  overflow: hidden;
  word-wrap: none;
  white-space: nowrap;
  color: #158DD3;
}
.database .databaseDetail .rig .commentPar .commentParLi .commentCont {
  width: 50%;
  margin: 0 2px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: #4c4b4b;
}
.database .databaseDetail .rig .commentPar .commentParLi .commentTime {
  width: 30%;
  color: #adabab;
  font-size: 12px;
}
.database .databaseDetail .rig .commentTextArea {
  width: 80%;
  height: 154px;
  margin: 0 auto;
  margin-top: 10px;
  line-height: 23px;
  font-size: 14px;
  padding: 3px;
  text-indent: 1em;
  resize: none;
}
.database .databaseDetail .rig .submitBtn {
  width: 80%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin: 20px auto;
  color: #fff;
  font-size: 14px;
  background-color: #158DD3;
  cursor: pointer;
  border-radius: 4px;
}
.perstyle {
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.2) 0%,
    rgba(0, 0, 0, 0) 100%
  ) !important;
}
.arMag {
  margin-left: 20px;
}
.fixLi {
  margin-right: 20px;
}
.database {
  margin-bottom: 60px;
}
/* .database .address {
  width: 100%;
  text-align: center;
  margin: 0 auto;
  font-size: 12px;
  color: gray;
  padding-bottom: 20px;
  position: fixed;
  background-color: #f1f1f1;
  bottom: 0;
  z-index: 999;
  padding-top: 20px;
} */
</style>



// WEBPACK FOOTER //
// src/components/database.vue